import { render } from "./CaseDetailsView.vue?vue&type=template&id=7f8a6192"
import script from "./CaseDetailsView.vue?vue&type=script&lang=js"
export * from "./CaseDetailsView.vue?vue&type=script&lang=js"

import "./CaseDetailsView.vue?vue&type=style&index=0&id=7f8a6192&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__